import * as React from "react";
import { PureComponent, ReactNode } from "react";
import { connect } from "react-redux";
import {
  fetchCurrentUser,
  checkSessionStatus,
  useEmbedTheme,
  SESSION_USE_EMBEDDED_THEME
} from "../actions";

import { RootDispatch, RootState } from "../../types";
import { User } from "../types";

interface StateProps {
  currentUser: User | null;
}

interface DispatchProps {
  fetchCurrentUser: () => void;
  checkSessionStatus: () => void;
  useEmbeddedTheme: () => void;
}

type Props = StateProps & DispatchProps & { children: ReactNode };

class SessionProvider extends PureComponent<Props> {
  public componentDidMount() {
    this.props.fetchCurrentUser();
    this.props.checkSessionStatus();
    const isEmbeddedSession = window.sessionStorage.getItem(SESSION_USE_EMBEDDED_THEME);
    if (isEmbeddedSession === "true") {
      this.props.useEmbeddedTheme();
    }
  }

  public componentWillUnmount() {
    clearTimeout(window.checkSessionStatusTimeoutHandle);
  }

  public render() {
    if (this.props.currentUser) {
      return React.Children.toArray(this.props.children);
    } else {
      return null;
    }
  }
}

export default connect(
  (state: RootState): StateProps => ({
    currentUser: state.session.data.currentUser
  }),
  (dispatch: RootDispatch) => ({
    fetchCurrentUser: () => dispatch(fetchCurrentUser()),
    checkSessionStatus: () => dispatch(checkSessionStatus()),
    useEmbeddedTheme: () => dispatch(useEmbedTheme())
  })
)(SessionProvider);
